import React from 'react';
import Cart from '../components/Card/Cart/Cart';

const CartPage = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <Cart />
    </div>
  );
};

export default CartPage;
